import React, { Component } from 'react';

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components
import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Face from "@mui/icons-material/Face";

// core components
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import Grid from "@mui/material/Grid";

import Card from "@mui/material/Card";

import { DataStatePage, Roles, TipoOthelloFieldGrid, OpcionSiNo } from "../othelloConstantes.jsx";
import OthelloTituloPanelData from '../componentsothello/OthelloTituloPanelData.jsx';

export default function Oficina({ ...props }) {

    const { literal, idRol } = props;

    const [loading, setLoading] = React.useState(true);
    const [statePage, setstatePage] = React.useState(DataStatePage.dsSearch);
    const [dataoficinas, setdataoficinas] = React.useState(null);

    const navigate = useNavigate()

    const location = useLocation();

    React.useEffect(() => {
        getDataPage();
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = () =>
    {
        fetch('api/Data/GetOficinasUsuario')
            .then(response => response.json())
            .then(data => {
                setdataoficinas(data);
                setLoading(false);
            });
    }

    //METODO SOBRE EL GRID 

    const editGridDataPage = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify({ id: valor.id_Oficina, name: valor.nomOficina });

            fetch('api/Data/SetIDOficinaSelected', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                //Si hubo error
                if (res) {
                    navigate('/admin/dashboard');
                    //navigate('/admin/almacen/albaranes', { state: valor });
                    //props.history.push('/admin/dashboard')
                    //window.location.assign('/admin/dashboard');
                }
            }).catch(error => {

            });
        }
    }

    const deleteGridDataPage = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_Oficina);

            fetch('api/Data/EliminarOficina', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res) {
                    if (dataoficinas != null) {
                        var array = [...dataoficinas]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataoficinas(array);                     
                    }
                }
            }).catch(error => {
            });
        }
    }


    function renderFormOficinas(datos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Nombre", "ID Oficina", "Baja"];

        let valoreshow = ["nomOficina", "id_Oficina", "baja"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "baja", items: OpcionSiNo });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onEdit={editGridDataPage} onDelete={idRol == Roles.SuperUsuario ? deleteGridDataPage : null} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={15} />);
    }

    let formulario = loading ? <p><CircularProgress color="secondary" /></p> : renderFormOficinas(dataoficinas);

    return (
        <Grid container>
            <Grid item xs={12}>
                <OthelloTituloPanelData tituloliteral="_misoficinas" margentop={0}>                
                    {/*<div color="rose" icon>*/}
                    {/*    <div color="rose">*/}
                    {/*        <Face />*/}
                    {/*    </div>*/}
                    {/*    <h4>Mis Oficinas</h4>*/}
                    {/*</div>*/}
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        {formulario}
                    </div>
                </OthelloTituloPanelData>
            </Grid>
        </Grid>
    );
}